import { renderToStaticMarkup } from "react-dom/server";
import { createElement } from "react";
import { PRINT_CSS, PRINT_FONTS_CSS, type PrintProduct } from "@/shared/lib/printLayout";
import { PrintPoster } from "./PrintPoster";

/**
 * Открывает макет в новом окне и вызывает печать. Разметка берётся из того же
 * компонента, что показан в превью, — расхождению между ними взяться неоткуда.
 */
export function openPrintWindow(
  url: string,
  qrSrc: string,
  logoSrc: string,
  product: PrintProduct,
): boolean {
  const printWindow = window.open("", "_blank");
  if (!printWindow) return false;

  const markup = renderToStaticMarkup(
    createElement(PrintPoster, { url, qrSrc, logoSrc, product }),
  );

  printWindow.document.write(
    '<!DOCTYPE html><html lang="ru"><head><meta charset="utf-8">' +
      `<title>${product.brand} — QR-плакат</title>` +
      "<style>@page { size: A4; margin: 0; } html, body { margin: 0; padding: 0; background: #fff; }\n" +
      `${PRINT_FONTS_CSS}\n${PRINT_CSS}` +
      "</style></head><body>" +
      markup +
      "</body></html>",
  );
  printWindow.document.close();
  printWindow.focus();
  void whenRendered(printWindow).then(() => printWindow.print());
  return true;
}

/**
 * Ждёт шрифты и картинки окна печати. Без этого лист уходит в печать до того,
 * как подгрузился Noto Sans, и печатается системным шрифтом.
 *
 * Ожидание ограничено по времени: если шрифт или логотип не отдались, лучше
 * напечатать макет с подстановкой, чем не напечатать вовсе.
 */
function whenRendered(printWindow: Window): Promise<unknown> {
  const doc = printWindow.document;
  const images = [...doc.images]
    .filter((image) => !image.complete)
    .map(
      (image) =>
        new Promise((resolve) => {
          image.addEventListener("load", resolve, { once: true });
          image.addEventListener("error", resolve, { once: true });
        }),
    );

  return Promise.race([
    Promise.all([doc.fonts.ready, ...images]),
    new Promise((resolve) => printWindow.setTimeout(resolve, 3000)),
  ]);
}
